import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { isUserLoggedIn } from '@app/app.reducer';
import { select, Store } from '@ngrx/store';
import { map, take } from 'rxjs';

@Injectable()
export class LoginGuardUser implements CanActivate {
  readonly #router = inject(Router);
  readonly #store = inject(Store);

  canActivate() {
    return this.#store.pipe(
      select(isUserLoggedIn),
      map((isLoggedIn) => {
        if (isLoggedIn) {
          return isLoggedIn;
        }

        this.#router.navigate(['/']);

        return false;
      }),
      take(1)
    );
  }
}
